module.exports = __webpack_public_path__ + "img/Vespaio Map icon@2x.59fff97f.png";